module.exports = __webpack_public_path__ + "static/media/david-edelstein-N4DbvTUDikw-unsplash.123bc8e8.webp";